import { render, staticRenderFns } from "./job_list.html?vue&type=template&id=2abbd3b2&scoped=true&"
import script from "./job_list.vue?vue&type=script&scoped=true&lang=js&"
export * from "./job_list.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./job_list.scss?vue&type=style&index=0&id=2abbd3b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbd3b2",
  null
  
)

export default component.exports